// extracted by mini-css-extract-plugin
export default {"contentContainer":"styles_contentContainer__+JUoc","tableContainer":"styles_tableContainer__idDGm"};